import { Component, AfterViewInit, HostListener } from '@angular/core';
import { Location, ViewportScroller } from '@angular/common';
import { Router, Scroll, NavigationEnd, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

/**
    * The Root component that Angular creates and inserts into the index.html host web page.
     */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  // tslint:disable-next-line:max-line-length
  behavior: ScrollBehavior = 'auto'; // set to smooth if desired.. currently becoming annoying if page length is longer and need to wait for scroll finish.
  scrollOffset = [0, -90]; // adjustment for header and to scroll till top of card

  currentRoutePath: string;

  constructor(private loc: Location, private router: Router, private viewportScroller: ViewportScroller) {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: any) => {
      // this.currentRoutePath = this.router.url.slice(6);
      this.currentRoutePath = this.router.url;
    });

    // this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((e: any) => {
    //   const pageTop = document.getElementById('PageTop');
    //   pageTop.removeEventListener('scroll', scroller);
    // });

    const self = this;
    const scroller = function(this: HTMLElement, ev: UIEvent){
      const pageTop = document.getElementById('PageTop');
      manageBackToTopVisibility(pageTop);
      const sections = document.querySelectorAll('[data-content-section]');
      if (sections.length > 0){
        const revSections = Array.from(sections).sort((a: Element, b: Element) => {
          return ((<HTMLElement>b).offsetTop - (<HTMLElement>a).offsetTop);
        });
        let highlightElement: HTMLElement;
        const routePath = self.currentRoutePath.split('#')[0];
        console.log(`routepath: ${routePath}`);
        if (pageTop.scrollTop > pageTop.scrollHeight - document.body.clientHeight - 10) {
          highlightElement = <HTMLElement>revSections[0];
        }
        for (let i = 0; i < revSections.length; i++) {
          if (!highlightElement) {
            if (pageTop.scrollTop >= ((<HTMLElement>revSections[i]).offsetTop - 100)) {
              highlightElement = <HTMLElement>revSections[i];
            } else {
              console.log('nav>a[href="' + routePath + '#' + revSections[i].id + '"]');

              const anchor = (<HTMLAnchorElement>document.querySelector('nav>a[href="' + routePath + '#' + revSections[i].id + '"]'));
              anchor.className = '';
            }
          } else {
            console.log('nav>a[href="' + routePath + '#' + revSections[i].id + '"]');

            const anchor = (<HTMLAnchorElement>document.querySelector('nav>a[href="' + routePath + '#' + revSections[i].id + '"]'));
            anchor.className = '';
          }
        }
        if (highlightElement) {
          const anchor = (<HTMLAnchorElement>document.querySelector('nav>a[href="' + routePath + '#' + highlightElement.id + '"]'));
          anchor.className = 'activeContent';
        }
      }
    };

    const manageBackToTopVisibility = function(pageTop: HTMLElement){
      if (pageTop.scrollTop < 20) {
        document.getElementById('backToTop').style.display = 'none';
      } else {
        document.getElementById('backToTop').style.display = 'block';
      }
    };

    this.router.events.pipe(filter(e => e instanceof Scroll)).subscribe((e: any) => {
      // this is fix for dynamic generated content
      setTimeout(() => {
        const pageTop = document.getElementById('PageTop');

        if (pageTop) {
          manageBackToTopVisibility(pageTop);
          pageTop.addEventListener('scroll', scroller);

          if (e.anchor) {
            if (e.anchor === 'PageTop') {
              pageTop.scrollTo({top: 0, behavior: this.behavior});
            } else {
              pageTop.scrollBy({top: document.getElementById(e.anchor).getBoundingClientRect().top + this.scrollOffset[1], behavior: this.behavior});
            }
          } else if (e.position) {
            pageTop.scrollTo({top: 0, behavior: this.behavior});
          } else {
            pageTop.scrollTo({top: 0, behavior: this.behavior});
          }
        }

      });
    });
  }


  locationBack() {
    window.history.back();
  }

  locationBackAngular() {
    this.loc.back();
  }
}
